<template>
    <el-dialog v-if="dialogFormVisible" v-el-drag-dialog :fullscreen="fullscreen" :visible.sync="dialogFormVisible" :close-on-click-modal="false" :width="winWidth + 'px'" :title="popTitle" @close="closeDialog">
        <div>
            <el-form :model="vo">
                <div class="el-table el-table--fit el-table--border">
                    <div class="el-table__body-wrapper">
                        <table cellspacing="0" cellpadding="0" border="0" class="el-table__body">
                            <tbody>
                                <tr>
                                    <td class="el-table__cell tdlbl tdw17">
                                        <span v-field-lbl="'operate'">接收人</span>
                                    </td>
                                    <td class="el-table__cell tdcont tdw83" style="text-align: left">
                                        <span v-if="xmArch.passenger.flCreatorAccount">{{ xmArch.flCreator }}</span>
                                        <ValidationProvider v-else ref="ValidationProvider" v-slot="{ errors }" name="接收人" rules="required">
                                            <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                                <el-input v-model="cbUrgedPerson" placeholder="请选择接收人" v-select-dialog="'staff'" name="cbUrgedPerson" />
                                            </el-tooltip>
                                        </ValidationProvider>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="el-table__cell tdlbl tdw17">
                                        <span class="required">*</span>
                                        <span v-field-lbl="'cbContent'">催办内容</span>
                                    </td>
                                    <td class="el-table__cell tdlbl tdw83">
                                        <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="催办内容" rules="required">
                                            <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                                <el-input v-model="vo.cbContent" type="textarea" rows="10" :placeholder="$tx('ecoa.urgeTodo.UrgentContentPlaceholder', '请填写催办内容')" />
                                            </el-tooltip>
                                        </ValidationProvider>
                                    </td>
                                </tr>
                                <!--tr>
                                    <td class="el-table__cell tdlbl tdw17">
                                        <span class="required">*</span>
                                        <span v-field-lbl="'operate'">催办方式</span>
                                    </td>
                                    <td class="el-table__cell tdlbl tdw83" style="text-align: left">
                                        <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="催办方式" rules="required">
                                            <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                                <el-checkbox-group v-model="type">
                                                    <el-checkbox v-for="(item, index) in listType" :key="index" :label="item.value">{{ item.name }}</el-checkbox>
                                                </el-checkbox-group>
                                            </el-tooltip>
                                        </ValidationProvider>
                                    </td>
                                </tr-->
                            </tbody>
                        </table>
                    </div>
                </div>
            </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button v-pageBtn-lbl="'close'" plain icon="el-icon-close" @click="closeDialog">关 闭</el-button>
            <el-button v-pageBtn-lbl="'UrgeProcessing'" type="primary" icon="el-icon-check" :disabled="submitStatus" @click="submitForm">催 办</el-button>
        </div>

        <select-dialog v-if="wflowview !== 'appMain'" />
    </el-dialog>
</template>

<script>
export default {
    components: {},
    props: {
        winWidth: { type: Number, default: 1000 }
    },
    data() {
        return {
            i18npkg: 'ecoa',
            moduleCode: 'urgeTodo',
            popTitle: this.$tx('ecoa.pageBtns.UrgeProcessing', '催 办'),
            dialogFormVisible: false,
            loading: false,
            xmArch: null,
            listType: [
                { name: this.$tx('ecoa.urgeTodo.textMessage', '短信'), value: '0' },
                { name: this.$tx('ecoa.urgeTodo.mail', '站内信'), value: '1' },
                { name: this.$tx('ecoa.urgeTodo.InstantMessaging', '即时通讯'), value: '2' }
            ],
            vo: {},
            cbUrgedPerson: '',
            type: ['1'],
            submitStatus: false
        }
    },
    computed: {},
    watch: {},
    created() {
        this.$bus.on('showUrgeFile', this.showUrgeFile)
    },
    mounted() {},
    beforeDestroy() {
        this.$bus.off('showUrgeFile', this.showUrgeFile)
    },
    methods: {
        showUrgeFile() {
            this.$app.addNew('/cuiban/cbfsjl/addNew', {}).then((res) => {
                if (res.code === 'success') {
                    this.xmArch = this.$vnode.context.vo
                    this.$set(this.vo, 'busiDataId', this.$route.query.busiDataId)
                    this.$set(this.vo, 'wfNodeNames', '资料移交')
                    this.$set(this.vo, 'wfEngineUrl', this.$route.query.wfEngineUrl)
                    this.$set(this.vo, 'module', this.$route.query.wfEngineUrl.split('/')[1])
                    this.$set(this.vo, 'jsTime', this.xmArch.flCreateDate)
                    this.$set(this.vo, 'cbUrgedPerson', this.xmArch.flCreator)
                    this.$set(this.vo, 'cbUrgedAccount', this.xmArch.passenger.flCreatorAccount)
                    this.$set(this.vo, 'cbContent', '【催办提醒】请收到此通知7日内完善《' + this.xmArch.flSubject + '》全部相关资料。')

                    this.dialogFormVisible = true
                }
            })
        },

        closeDialog() {
            this.dialogFormVisible = false
            this.fullscreen = false
            this.vo = {}
        },
        onSelectStaffCompleted(selectedNodes, attr) {
            this.$set(this, 'cbUrgedPerson', selectedNodes[0].name)
            this.$set(this.vo, 'cbUrgedAccount', selectedNodes[0].account)
            this.$set(this.vo, 'cbUrgedPerson', selectedNodes[0].name)
        },
        async submitForm() {
            this.formValidate(() => {
                if (this.vo.cbUrgedAccount === '' || this.vo.cbUrgedAccount === null || this.vo.cbUrgedAccount === undefined) {
                    // this.$alert('请选择被催办人', '操作提示', {
                    //     confirmButtonText: '确定',
                    //     type: 'warning'
                    // })
                    this.$alert(this.$tx('ecoa.messages.submitFormPersonAlert', '请选择被催办人'), this.$tx('common.operationTip', '操作提示'), {
                        confirmButtonText: this.$tx('pageBtns.sure', '确 定'),
                        type: 'warning'
                    })
                    return
                }

                const arr = []
                arr.push({
                    cbUrgedPerson: this.vo.cbUrgedPerson,
                    cbUrgedPersonAccount: this.vo.cbUrgedAccount,
                    wfNodeNames: '资料移交',
                    elevel: '',
                    jsTime: this.xmArch.flCreateDate
                })
                this.vo.sendType = this.type.join(',')
                this.submitStatus = true
                const data = JSON.parse(JSON.stringify(this.vo))
                new Promise((resolve, reject) => {
                    const res = this.$app.insert('/cuiban/cbfsjl/insertList?module=' + data.module, { cbfsjl: data, cbjsjl: arr })
                    resolve(res)
                }).then((res) => {
                    if (res.code === 'success') {
                        this.closeDialog()

                        this.$message({
                            message: this.$tx('ecoa.urgeTodo.subSuccessMsg', '催办成功'),
                            type: 'success',
                            onClose: function () {
                                if (typeRow !== 'list') {
                                    location.reload()
                                }
                            }
                        })
                    } else {
                        this.$alert(res.message, this.$tx('common.operationTip', '操作提示'), { type: 'error' })
                    }
                    this.submitStatus = false
                })
            })
        }
    }
}
</script>

<style scoped lang="scss"></style>
